import { useRouteMatch } from 'react-router';
import { validateStrEnumValue } from '@mobalytics/shared';
import { parseAppQueryParams } from '../../../utils/url';
import { useAppStore } from '../../../store/app-store.hook';
import { PaymentError } from '../payment-error.types';

export const usePaymentV2UrlParams = () => {
  const { params } = useRouteMatch<{ productId: string; priceId?: string; state?: 'success' | 'error' }>();
  const { productId, priceId, state } = params;
  const queryParams = parseAppQueryParams();
  const redirectStatus = queryParams.redirect_status;
  const { productAbbreviation } = useAppStore().configStore;
  const checkout = state
    ? state === 'success'
      ? { state: 'success' as const }
      : {
          state: 'error' as const,
          errorCode:
            validateStrEnumValue<PaymentError>(PaymentError, queryParams.error_code) || PaymentError.INTERNAL_ERROR,
        }
    : undefined;

  return {
    productId,
    priceId,
    checkout,
    productAbbreviation,
    redirectStatus,
  };
};
